<template>
  <v-container>
    <v-card class="pa-5">
      <h2>Artist Research</h2>
      <form id="search-form" @submit.prevent="submitQuery">
        <div v-if="currentStep === 1">
          <textarea
            placeholder="Who would you like to research?"
            v-model="artistName"
            rows="4"
            class="form-control inputarea card-animate-2"
          ></textarea>
          <br />

          <v-btn class="btn-primary" @click="handleOption(1)">Start Research</v-btn>
          <v-btn class="btn btn-secondary" @click="activateForm">Fill Research Form</v-btn>
        </div>
      </form>
      </v-card>
    </v-container>
  </template>

<script>
// import AnimationPaste from '../components/AnimationPaste.vue';
// import startAudioVisual from '../assets/audio/SelectUI.wav';

export default {
  components: {
    // AnimationPaste,
  },
  data() {
    return {
      artistName: '',
      currentStep: 1,
      overlay: false,
      queryPrompt: '',
      isRecording: false,
      recordingStateColor: 'blue',
    };
  },
  methods: {
    async submitQuery() {
      if (!this.artistName) return;

      this.overlay = true;
      const msg = this.artistName;

      // Option 1
      const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message: msg }),
      });
      const content = await rawResponse.json();
      let message = content.message.replace(/AI/g, '').replace(/:/g, '');
      this.$store.commit('updateMessage', { message });
      this.readOutLoud('Commencing research for ' + msg + '.......' + message);

      setTimeout(() => { this.overlay = false; }, 18000);

      setTimeout(() => {
        const query = encodeURIComponent(msg);
        window.open(`https://www.billboard.com/search?q=${query}`, '_blank');
        window.open(`https://www.pollstar.com/search?query=${query}`, '_blank');
      }, 20000);

      setTimeout(() => {
        this.overlay = false;
      }, 24000);
    },

    // Option 2 - populate form
    activateFormFilling() {
      this.queryPrompt = `Browse www.billboard.com and www.pollstar.com to research "${this.artistName}"`;
      this.readOutLoud(`Researching ${this.artistName}. Please specify what you want to achieve.`);
      this.currentStep = 1;
    },

    promptUserAndStartRecording() {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognition = new SpeechRecognition();
      recognition.lang = 'en-US';
      recognition.start();

      recognition.onstart = () => (this.recordingStateColor = 'blue');

      recognition.onresult = (event) => {
        this.queryPrompt += event.results[0][0].transcript;
        this.recordingStateColor = 'red';
        this.stopRecording();
      };

      recognition.onerror = (event) => {
        console.error('Speech recognition error', event);
        this.isRecording = false;
      };

      this.isRecording = true;
    },

    stopRecording() {
      this.recordingStateColor = 'blue';
      this.isRecording = false;
    },

    readOutLoud(msg) {
      const speech = new SpeechSynthesisUtterance(msg);
      window.speechSynthesis.speak(speech);
    },
  },
};
</script>

<style scoped>
.card-animate-2 {
  animation: fadeIn 1.2s ease;
}

.form-control {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.inputarea {
  font-size: 1rem;
  resize: vertical;
}

</style>
